
(() => {
  const isEnglish = document.documentElement.lang.toLowerCase().startsWith('en');

  const OLD_RETURN_COPY = '15 días para devolver el producto';

  const NEW_RETURN_COPY = isEnglish
    ? '14 days to return your order'
    : '14 días para devolver el producto';

  const ONE_TIME_SHIPPING_COPY = isEnglish
    ? '+€2.97 shipping to mainland Spain'
    : '+2,97€ envío península';

  const updateReturnCopy = (root = document) => {
    root.querySelectorAll?.('.elixiva-pdp__subscription-benefit-text').forEach((element) => {
      const currentText = element.textContent.trim();

      if (
        currentText === OLD_RETURN_COPY ||
        currentText === '14 días para devolver el producto' ||
        currentText === '15 days to return your order' ||
        currentText === '14 days to return your order'
      ) {
        element.textContent = NEW_RETURN_COPY;
      }
    });
  };

  const addOneTimeShippingCopy = (root = document) => {
    root.querySelectorAll?.(
      '.elixiva-pdp__purchase-price:not(.elixiva-pdp__purchase-price--subscription)'
    ).forEach((price) => {
      let shipping = price.querySelector('.elixiva-pdp__one-time-shipping');

      if (!shipping) {
        shipping = document.createElement('small');
        shipping.className = 'elixiva-pdp__one-time-shipping';
        price.appendChild(shipping);
      }

      shipping.textContent = ONE_TIME_SHIPPING_COPY;
    });
  };

  const applyPdpCopyFixes = (root = document) => {
    updateReturnCopy(root);
    addOneTimeShippingCopy(root);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => applyPdpCopyFixes(), { once: true });
  } else {
    applyPdpCopyFixes();
  }

  document.addEventListener('shopify:section:load', (event) => {
    applyPdpCopyFixes(event.target);
  });
})();
